/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Not_Found_DescInputs */

const en_directory_not_found_desc = /** @type {(inputs: Directory_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tool or category you're looking for may have been removed or renamed. Try a search, or browse the directory.`)
};

const zh_directory_not_found_desc = /** @type {(inputs: Directory_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你访问的工具或分类可能已下线或改名。试试搜索，或浏览工具目录。`)
};

/**
* | output |
* | --- |
* | "The tool or category you're looking for may have been removed or renamed. Try a search, or browse the directory." |
*
* @param {Directory_Not_Found_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_not_found_desc = /** @type {((inputs?: Directory_Not_Found_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Not_Found_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_not_found_desc(inputs)
	return zh_directory_not_found_desc(inputs)
});
export { directory_not_found_desc as "directory.not_found.desc" }